var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.finishedPlaying)?_c('article',{class:{
    'activity-video': true,
    'activity-video--fullscreen': _vm.fullscreen,
  },attrs:{"data-activity-asset":""}},[_c('div',{staticClass:"activity-video__element"},[_c('AssetVideo',{key:_vm.videoSrc,ref:"video",attrs:{"id":_vm.data[0].id,"src":_vm.isOnline ? _vm.videoSrc : _vm.findPreloadedAsset('video', _vm.videoSrc),"type":_vm.type,"autoplay":_vm.autoPlay,"play-slow":_vm.playSlow},on:{"ended":_vm.handleVideoEnded,"on-fullscreen":_vm.onFullscreen}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }